'use client';

import { cn } from '@/lib/utils';
import { useGetImagesQuery } from '@/redux/api/galleryApi';
import { EmblaOptionsType } from 'embla-carousel';
import { Card } from '../ui/card';
import EmblaCarousel from '../ui/embla-carousel/embla-carousel';
import { Skeleton } from '../ui/skeleton';

const OPTIONS: EmblaOptionsType = {
  loop: true,
  align: 'center',
};

const ProductSlider = () => {
  const { data, isLoading, isError } = useGetImagesQuery(undefined);
  const gallery = data?.body;

  if (isLoading)
    return (
      <Card className={cn('mx-auto w-full max-w-3xl overflow-hidden')}>
        <div className="relative">
          {/* Main image skeleton */}
          <Skeleton className="aspect-[16/9] w-full" />

          {/* Navigation buttons skeletons */}
          <div className="absolute inset-0 flex items-center justify-between p-4">
            <Skeleton className="h-10 w-10 rounded-full" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>

          {/* Indicators skeleton */}
          <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 space-x-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-2 w-2 rounded-full" />
            ))}
          </div>
        </div>

        {/* Thumbnails skeleton */}
        <div className="flex justify-center space-x-2 p-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="aspect-[4/3] w-20" />
          ))}
        </div>
      </Card>
    );

  if (isError) {
    return null;
  }

  // if(isError){
  //   return null;
  // }

  if (!gallery || gallery.length === 0) {
    return (
      <div className="text-center text-gray-600">
        <p>No images available to display at the moment.</p>
      </div>
    );
  }

  return (
    <div className="">
      <EmblaCarousel slides={gallery} options={OPTIONS} />
    </div>
  );
};

export default ProductSlider;
